import classNames from 'classnames'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { useThemeContext } from 'src/context/theme'

// selectors
import {
  selectAppreciationRelevancy,
  selectCashPositionRelevant,
  selectCashPositionGood,
  selectPositiveIndicatorsCount,
} from 'src/store/selectors/shouldYouSell'

// Constants
import { OVERLAY_HELPERS } from 'src/constants/navigation'

// components
import SectionWrapper from 'src/Components/shared/SectionWrapper'
import { Text, If, Unless, Button } from 'src/Components'
import { selectShouldRenderThinkingOfSelling } from 'src/store/selectors/display'
import history from 'src/history'
import AppreciationLabel from '../ShouldYouSell/Appreciation/AppreciationLabel/AppreciationLabel'
import { GoodCashPositionLabel } from '../ShouldYouSell/CashPosition/Good'
import { BadCashPositionLabel } from '../ShouldYouSell/CashPosition/Bad'
import MarketTempSellLabel from '../ShouldYouSell/MarketTempSell/MarketTempSellLabel'

// styles
import baseStyles from '../MarketSpotlight.module.scss'
import styles from './ThinkingOfSelling.module.scss'

const ThinkingOfSelling = () => {
  const shouldRender = useSelector(selectShouldRenderThinkingOfSelling)
  const cashPositionRelevant = useSelector(selectCashPositionRelevant)
  const appreciationRelevant = useSelector(selectAppreciationRelevancy)
  const goodCashPosition = useSelector(selectCashPositionGood)
  const positiveIndicatorsCount = useSelector(selectPositiveIndicatorsCount)
  const { isLightThemeType } = useThemeContext()

  const handleNavigateToShouldYouSell = () => {
    history.push(OVERLAY_HELPERS.shouldYouSell.buildPath())
  }

  return (
    <If condition={shouldRender}>
      <SectionWrapper
        className={classNames(baseStyles.section, styles.panel)}
        data-qa='thinking-of-selling'
      >
        <Text
          size='xs'
          variant='neutralCool'
          variantCount='600'
          weight='semibold'
          className={styles.header}
        >
          <FormattedMessage
            id='MarketSpotlight.thinkingOfSelling.header'
            defaultMessage='Thinking of Selling your home?'
          />
        </Text>
        <Text
          size='m'
          variant='neutralCool'
          variantCount='900'
          className={styles.subheader}
        >
          <If condition={positiveIndicatorsCount >= 2}>
            <FormattedMessage
              id='MarketSpotlight.thinkingOfSelling.subheader.positive'
              defaultMessage='Now might be a good time - You have {count} strong selling signals'
              values={{
                count: positiveIndicatorsCount,
              }}
            />
          </If>
          <Unless condition={positiveIndicatorsCount >= 2}>
            <FormattedMessage
              id='MarketSpotlight.thinkingOfSelling.subheader.negative'
              defaultMessage='These signals indicate it may not be an ideal time to sell'
            />
          </Unless>
        </Text>
        <div className={styles.indicators}>
          <If condition={appreciationRelevant}>
            <div className={styles.labels}>
              <AppreciationLabel />
            </div>
          </If>
          <If condition={cashPositionRelevant}>
            <div className={styles.labels}>
              <If condition={goodCashPosition}>
                <GoodCashPositionLabel />
              </If>
              <Unless condition={goodCashPosition}>
                <BadCashPositionLabel />
              </Unless>
            </div>
          </If>
          <div className={styles.labels}>
            <MarketTempSellLabel />
          </div>
        </div>
        <Button
          className={styles.moreDetailsButton}
          onClick={handleNavigateToShouldYouSell}
        >
          <FormattedMessage
            id='ShouldYouSell.thinkingOfSelling.navigation.text'
            defaultMessage='More details on this'
          />
        </Button>
      </SectionWrapper>
    </If>
  )
}

export default ThinkingOfSelling
